export default "__VITE_ASSET__BG9Z6MWf__"